export const GAS_LIMIT_SAFETY_OFFSET = 50_000

// TODO: estimate all of it
export const DEPOSIT_GAS_LIMIT = 420_000
export const WITHDRAW_GAS_LIMIT = 250_000
export const BUY_GAS_LIMIT = 340_000
export const SELL_GAS_LIMIT = 340_000

export const EXECUTE_DEPOSIT_GAS_LIMIT = 630_000
export const EXECUTE_WITHDRAW_GAS_LIMIT = 400_000
export const EXECUTE_BUY_GAS_LIMIT = 480_000
export const EXECUTE_SELL_GAS_LIMIT = 480_000

export const MAX_DEFAULT_GAS_LIMIT = 420_000
